import React from 'react';
import styled from 'styled-components';
import { ButtonRow, Button } from './StyledComponents';

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 5px;
  width: ${({ width }) => width || '400px'};
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  font-family: 'Poppins', sans-serif;
`;

const Title = styled.div`
  font-size: 1.2rem;
  text-align: left;
  background-color: #85B33E;
  font-weight:500;
  color: #ffffff;
  margin: 2px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const Message = styled.div`
  font-size: 1.2rem;
  margin-bottom: 16px;
  padding:0 16px;
  color: #333;

  a {
    color: #007bff;
    text-decoration: underline;
  }
`;

export default function ConfirmModal({ title, children, buttons = [], onClose, width }) {
  return (
    <Overlay onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()} width={width}>
        <Title>{title}</Title>
        <Message>
          {typeof children === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: children }} />
          ) : (
            children
          )}</Message>
        <ButtonRow $padding="10px 10px 16px 10px">
          {buttons.map((btn, index) => (
            <Button
              key={index}
              variant={btn.variant}
              onClick={btn.onClick}
            >
              {btn.icon && <i className={btn.icon}></i>}
              {btn.label}
            </Button>
          ))}
        </ButtonRow>
      </ModalBox>
    </Overlay>
  );
}
